import React, { FC } from 'react';
import * as Styled from './HeaderTitle.styles';

interface HeaderTitleProps {
  title: string;
}

const HeaderTitle: FC<HeaderTitleProps> = ({ title }) => {
  return (
    <Styled.HeaderTitleContainer>
      <Styled.HeaderTitleContent>
        <Styled.HeaderTitle>{title}</Styled.HeaderTitle>
      </Styled.HeaderTitleContent>
    </Styled.HeaderTitleContainer>
  );
};

export default HeaderTitle;
